import { Box, TextField } from '@mui/material';
import { useState, type CSSProperties } from 'react';
import { ThemePalette } from 'mui.theme';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface Props {
  data: Record<string, string>;
  field: string;
  style?: CSSProperties;
  onChange: (data: any, param: any) => void;
  enableDarkTheme: boolean;
}

export const TextFieldRenderer = ({
  data,
  field,
  onChange,
  enableDarkTheme = false,
}: Props) => {
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const [value, setValue] = useState(data[field] ?? '');

  return (
    <Box justifyContent={'center'}>
      <TextField
        disabled={!data.isActive}
        sx={{
          color: palette.textPrimary,
          display: 'flex',
          '& .MuiInputBase-root': {
            height: '30px',
            width: '275px',
          },
          ...(enableDarkTheme
            ? { backgroundColor: 'inherit' }
            : { WebkitBoxShadow: '0 0 0 1000px white inset' }),
          ...(enableDarkTheme && {
            border: `1px solid ${String(palette.borderGrey)}`,
          }),
          ...(enableDarkTheme && {
            input: {
              color: ThemePalette.typography.wheat,
            },
          }),
        }}
        value={value}
        onChange={(event) => {
          setValue(event.target.value);
        }}
        onBlur={() => {
          onChange(data, value);
        }}
      />
    </Box>
  );
};
